<svg *ngIf="cell.show" sh-icon [name]="'check'" aria-hidden="true"></svg>
